import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hola, Soy Franco Rios`}</h1>
    <p>{`Me gusta crear cosas digitales, desde una simple idea a algo visible o ejecutable, porque programar es crear y eso es cool 😎`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      